import {useBookingStore} from "../../Registration/stores/bookingStore";
import {computed} from "vue";
import {useLivewireBackend} from "../../Registration/composables/useBackendAdapter";

export function useFormField(item, group = null, groupId = null, mapToBooking = (v) => v, mapToField = (v) => v, backend = null) {

    // Default to Livewire backend for backward compatibility
    const backendAdapter = backend || useLivewireBackend();
    const store = useBookingStore();

    const path = () => {
        if (!group) return item.form_mapping
        const i = store.data[group].findIndex(g => g.uniqueId === groupId)
        return i >= 0 ? `${group}.${i}.${item.form_mapping}` : item.form_mapping
    }

    const getPrefix = () => {
        if (!group || !groupId) return '';
        return `companions.${groupId}.`;
    };

    const hasError = computed(() => {
        return backendAdapter.getErrors().hasOwnProperty(path());
    })

    const isReadOnly = computed(() => {
        if (item.read_only === true) {
            // const initialValue = backendAdapter.getInitialData(path());

            // if (initialValue !== null && initialValue !== '' &&
            //     !(Array.isArray(initialValue) && initialValue.length === 0)) {
                return true;
            // }
        }
        return false;
    })

    const model = computed({
        get: () => mapToField(backendAdapter.getData(path())),
        set: (value) => {
            if (!isReadOnly.value) {
                backendAdapter.updateField(path(), mapToBooking(value));
            }
        },
    })

    let uniqueItemId = `form-field`;
    if (group !== null) {
        uniqueItemId += `-${group}-${groupId}`;
    }
    uniqueItemId += `-${item.id}`

    const options = computed(() => {
        const hasOrder = item.options?.some(o => o.order !== null)
        return hasOrder
            ? [...item.options].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            : item.options
    })


    const inputAttributes = computed(() => {
        const baseAttributes = {
            "aria-describedby": hasError.value ? `error-${path()}` : item.label,
            "aria-invalid": hasError.value,
            "aria-required": item.required ? 'true' : 'false',
            "required": item.required && !isReadOnly.value,
        };

        if (isReadOnly.value) {
            baseAttributes.disabled = true;
            baseAttributes.readonly = true;
            baseAttributes.tabindex = -1; // Remove from tab order
        }

        return baseAttributes;
    })

    const getFieldClasses = (baseClasses = '') => {
        let classes = baseClasses;
        classes += ' form-group form-wrapper';
        if (hasError.value) {
            classes += ' registration-field-error';
        }

        if (isReadOnly.value) {
            classes += ' is-readonly';
        }

        return classes.trim();
    }

    const createBlurHandler = (emit) => {
        return () => {
            if (isReadOnly.value) return;

            emit('blur', {
                path: path(),
                value: model.value,
                item: item
            });
        };
    }

    const createInputHandler = (emit) => {
        return () => {
            if (isReadOnly.value) return;

            emit('input', {
                path: path(),
                value: model.value,
                item: item
            });
        };
    }

    return {
        model,
        uniqueItemId,
        options,
        path: path(),
        hasError,
        inputAttributes,
        isReadOnly,
        getFieldClasses,
        getPrefix,
        createBlurHandler,
        createInputHandler
    }
}
